/* eslint no-console:0 */
// esbuild が app/legacy/CSS をバンドルするエントリ (#2463)。propshaft が
// app/assets/builds を digest し /statics から配信する。

import { Turbo } from '@hotwired/turbo-rails';
import axios from 'axios';
import './controllers';
// Bootstrap JS only (CSS comes from the sass bundle)
import * as bootstrap from 'bootstrap';
// BS5 の data-API を確定的に配線する(tree-shaking で失われる副作用の代替)。
// jQuery 撤去 (#2428) で data-bs-toggle/dismiss が沈黙した回帰への対処。
import './bootstrap_data_api';
import mountReact from './mount_react';

// react_component ヘルパが吐いた data-react-class ノードへ React 島をマウントし、
// Turbo ナビゲーションにも追従させる。
mountReact();

// Maintain a window-level counter of in-flight axios requests so RSpec system
// specs can poll `window.axiosPendingRequests` from `wait_for_ajax` and reliably
// wait for XHR completion (Capybara's default polling has no XHR awareness).
window.axiosPendingRequests = 0;

// 状態を変える axios リクエストに Rails の CSRF トークンを自動付与する。
// Turbo Drive はグローバル無効 (下記) で axios は fetch/XHR のため UJS の
// 自動トークンが効かない。トークンは毎回 DOM から読む (import 時読みだと
// DOM 未準備で null になりうる)。既にヘッダがある呼び出しは尊重する。
// axios 1.x の config.headers は AxiosHeaders インスタンス。プレーンオブジェクトで
// 置き換えるとリクエストが壊れるため、必ず .set / .has / .get を使う。
const CSRF_SAFE_METHODS = ['get', 'head', 'options', 'trace'];

// 送信先が自オリジンのときだけトークンを付ける。将来 absolute URL への POST が
// 入ってもセッションの CSRF トークンを第三者へ送らないための防御。
const isSameOrigin = (url) => {
  try {
    return new URL(url || '', window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
};

axios.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  if (!CSRF_SAFE_METHODS.includes(method) && isSameOrigin(config.url)) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    // 呼び出し側が既にトークンを付けている場合は上書きしない。
    if (token && config.headers && !config.headers.has('X-CSRF-Token')) {
      config.headers.set('X-CSRF-Token', token);
    }
  }
  return config;
});

axios.interceptors.request.use((config) => {
  window.axiosPendingRequests = (window.axiosPendingRequests || 0) + 1;
  return config;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return response;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});

Turbo.session.drive = false;
window.Turbo = Turbo;
// Expose Bootstrap globally so RSpec system specs can poll
// `window.bootstrap` to know that the BS5 ESM bundle has finished
// executing and `data-bs-toggle="modal"` click handlers are ready.
// Without this signal, Capybara can click a modal-trigger before
// Bootstrap binds, and the click is silently dropped.
window.bootstrap = bootstrap;
